module.exports = __webpack_public_path__ + "img/scroll-mobile.a233aea7.svg";